module.exports = require("./es-BR.js");